/* global $:false, swal:false */
(function() {
  'use strict';

  angular
    .module('pub.channel.translation.edit', [
        'pub.channels.translation.service',
    ])
    .controller('TranslationChannelEditCtrl', TranslationChannelEditCtrl);

  /** @ngInject */
  function TranslationChannelEditCtrl($scope, $stateParams, $state, TranslationChannelService, ChannelsService, UploadService) {
    var vm = this;
    vm.model = {};
    vm.loadF = false;
    vm.loadT = false;
    vm.loadH = false;
    vm.loadL = false;
    vm.loadS = false;
    vm.loadW = false;
    vm.loadLSM = false;
    vm.loadDSM = false;
    vm.loadLLG = false;
    vm.loadDLG = false;
    vm.loadT11 = false;
    vm.loadT12 = false;
    vm.loadT13 = false;
    vm.loadT22 = false;
    vm.loadLand = false;
    vm.pathImgF = '';
    vm.pathImgT = '';
    vm.pathImgH = '';
    vm.pathImgL = '';
    vm.pathImgS = '';
    vm.pathImgW = '';
    vm.pathImgLSM = '';
    vm.pathImgDSM = '';
    vm.pathImgLLG = '';
    vm.pathImgDLG = '';
    vm.pathImgT11 = '';
    vm.pathImgT21 = '';
    vm.pathImgT31 = '';
    vm.pathImgT22 = '';
    vm.pathScreen = '';
    vm.pathImgLand = '';
    vm.id = parseInt($stateParams.translationId);

    function load(){
      if (vm.id !== 0) {
        TranslationChannelService.getTranslation(vm.id).then(function(result){
          vm.model = result.results;
          vm.pathImgT = vm.model['img-t'];
          vm.pathImgH = vm.model['img-h'];
          vm.pathImgL = vm.model['img-s-s'];
          vm.pathImgS = vm.model['img-s'];
          vm.pathImgW = vm.model['img-wel'];
          vm.pathImgLSM = vm.model['img-logo-l-sm'];
          vm.pathImgDSM = vm.model['img-logo-d-sm'];
          vm.pathImgLLG = vm.model['img-logo-l-lg'];
          vm.pathImgDLG = vm.model['img-logo-d-lg'];
          vm.pathImgLand = vm.model['img-web-l']  === undefined ? '' : vm.model['img-web-l'];
          vm.pathImgT11 = vm.model['img-11'] === undefined ? '' : vm.model['img-11'];
          vm.pathImgT21 = vm.model['img-21'] === undefined ? '' : vm.model['img-21'];
          vm.pathImgT31 = vm.model['img-31'] === undefined ? '' : vm.model['img-31'];
          vm.pathImgT22 = vm.model['img-22'] === undefined ? '' : vm.model['img-22'];
        });
      }
    }

    load();

    vm.save = function(){
      if (!vm.model.t) {
        swal('Title is required', '', 'error');
        return;
      }
      if (!vm.model.comm) {
        swal('Locale is required', '', 'error');
        return;
      }

      if (vm.model.id) {
        vm.model['id-ch'] = parseInt($stateParams.parentId);
        TranslationChannelService.updateTranslation(vm.model.id, vm.model).then(function(){
          $state.go('pub.channels.translation', { parentId: vm.model['id-ch'] })
        }, function(err){
          swal(err.error.message, "", "error");
        });
      } else {
        vm.model['id-ch'] = parseInt($stateParams.parentId);
        TranslationChannelService.createTranslation(vm.model['id-ch'], vm.model).then(function(){
          $state.go('pub.channels.translation', { parentId: vm.model['id-ch'] })
        }, function(err){
          swal(err.error.message, "", "error");
        });
      }
    }

    vm.cancel = function() {
      $state.go('pub.channels.translation', { parentId: parseInt($stateParams.parentId) })
    }

    var watch = $scope.$watch('vm.fileImgT', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadT = false;
        return;
      }

      if (newVal === null){
        vm.loadT = false;
        return;
      }

      vm.loadT = true;
      UploadService.save('channels', newVal, 'img-t', $stateParams.id).then(function(fileName){
        vm.loadT = false;
        vm.model['img-t'] = fileName;
        vm.pathImgT = fileName;
      });

    });

    var watch1 = $scope.$watch('vm.fileImgH', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadH = false;
        return;
      }

      if (newVal === null){
        vm.loadH = false;
        return;
      }

      vm.loadH = true;
      UploadService.save('channels', newVal, 'img-h', $stateParams.id).then(function(fileName){
        vm.loadH = false;
        vm.model['img-h'] = fileName;
        vm.pathImgH = fileName;
      });

    });

    var watch2 = $scope.$watch('vm.fileImgL', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadL = false;
        return;
      }

      if (newVal === null){
        vm.loadL = false;
        return;
      }

      vm.loadL = true;
      UploadService.save('channels', newVal, 'img-s-s', $stateParams.id).then(function(fileName){
        vm.loadL = false;
        vm.model['img-s-s'] = fileName;
        vm.pathImgL = fileName;
      });

    });

    var watch3 = $scope.$watch('vm.cover', function(newVal, oldVal){
      if (newVal === oldVal) {
        return;
      }

      if (newVal === null){
        return;
      }

      $('html, body').animate({ scrollTop: 0 }, 'fast');
      UploadService.save('channels', newVal, 'img-c', $stateParams.id).then(function(fileName){
        swal('Upload complete !');
        var top = ($('.preview').height() - 40) - (($('.preview').height() - 40) * 2);
        var right = 3;
        $('.iphone-screen')
          .css('margin-top', top)
          .css('margin-right', right);
        vm.pathScreen = fileName;
      });

    });

    var watch4 = $scope.$watch('vm.fileImgS', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadS = false;
        return;
      }

      if (newVal === null){
        vm.loadS = false;
        return;
      }

      vm.loadS = true;
      UploadService.save('channels', newVal, 'img-s', $stateParams.id).then(function(fileName){
        vm.loadS = false;
        vm.model['img-s'] = fileName;
        vm.pathImgS = fileName;
      });

    });

    var watch5 = $scope.$watch('vm.fileImgW', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadW = false;
        return;
      }

      if (newVal === null){
        vm.loadW = false;
        return;
      }

      vm.loadW = true;
      UploadService.save('channels', newVal, 'img-wel', $stateParams.id).then(function(fileName){
        vm.loadW = false;
        vm.model['img-wel'] = fileName;
        vm.pathImgW = fileName;
      });

    });

    var watch6 = $scope.$watch('vm.fileImgLSM', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadLSM = false;
        return;
      }

      if (newVal === null){
        vm.loadLSM = false;
        return;
      }

      vm.loadLSM = true;
      UploadService.save('channels', newVal, 'img-logo-l-sm', $stateParams.id).then(function(fileName){
        vm.loadLSM = false;
        vm.model['img-logo-l-sm'] = fileName;
        vm.pathImgLSM = fileName;
      });

    });

    var watch7 = $scope.$watch('vm.fileImgDSM', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadDSM = false;
        return;
      }

      if (newVal === null){
        vm.loadDSM = false;
        return;
      }

      vm.loadDSM = true;
      UploadService.save('channels', newVal, 'img-logo-d-sm', $stateParams.id).then(function(fileName){
        vm.loadDSM = false;
        vm.model['img-logo-d-sm'] = fileName;
        vm.pathImgDSM = fileName;
      });

    });

    var watch8 = $scope.$watch('vm.fileImgLLG', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadLLG = false;
        return;
      }

      if (newVal === null){
        vm.loadLLG = false;
        return;
      }

      vm.loadLLG = true;
      UploadService.save('channels', newVal, 'img-logo-l-lg', $stateParams.id).then(function(fileName){
        vm.loadLLG = false;
        vm.model['img-logo-l-lg'] = fileName;
        vm.pathImgLLG = fileName;
      });

    });

    var watch9 = $scope.$watch('vm.fileImgDLG', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadDLG = false;
        return;
      }

      if (newVal === null){
        vm.loadDLG = false;
        return;
      }

      vm.loadDLG = true;
      UploadService.save('channels', newVal, 'img-logo-d-lg', $stateParams.id).then(function(fileName){
        vm.loadDLG = false;
        vm.model['img-logo-d-lg'] = fileName;
        vm.pathImgDLG = fileName;
      });

    });

    var watch10 = $scope.$watch('vm.fileImgF', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadDLG = false;
        return;
      }

      if (newVal === null){
        vm.loadDLG = false;
        return;
      }

      vm.loadDLG = true;
      UploadService.save('features', newVal, 'img', $stateParams.id).then(function(fileName){
        vm.loadDLG = false;
        vm.model['img-logo-d-lg'] = fileName;
        vm.pathImgDLG = fileName;
      });

    });

    var watch11 = $scope.$watch('vm.fileImgT11', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadT11 = false;
        return;
      }

      if (newVal === null){
        vm.loadT11 = false;
        return;
      }

      vm.loadT11 = true;
      UploadService.save('channels', newVal, 'img-11', $stateParams.id).then(function(fileName){
        vm.loadT11 = false;
        vm.model['img-11'] = fileName;
        vm.pathImgT11 = fileName;
      });

    });

    var watch12 = $scope.$watch('vm.fileImgT21', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadT21 = false;
        return;
      }

      if (newVal === null){
        vm.loadT21 = false;
        return;
      }

      vm.loadT21 = true;
      UploadService.save('channels', newVal, 'img-21', $stateParams.id).then(function(fileName){
        vm.loadT21 = false;
        vm.model['img-21'] = fileName;
        vm.pathImgT21 = fileName;
      });
    });

    var watch13 = $scope.$watch('vm.fileImgT31', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadT31 = false;
        return;
      }

      if (newVal === null){
        vm.loadT31 = false;
        return;
      }

      vm.loadT31 = true;
      UploadService.save('channels', newVal, 'img-31', $stateParams.id).then(function(fileName){
        vm.loadT31 = false;
        vm.model['img-31'] = fileName;
        vm.pathImgT31 = fileName;
      });
    });

    var watch14 = $scope.$watch('vm.fileImgT22', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadT22 = false;
        return;
      }

      if (newVal === null){
        vm.loadT22 = false;
        return;
      }

      vm.loadT22 = true;
      UploadService.save('channels', newVal, 'img-22', $stateParams.id).then(function(fileName){
        vm.loadT22 = false;
        vm.model['img-22'] = fileName;
        vm.pathImgT22 = fileName;
      });
    });

    var watch15 = $scope.$watch('vm.fileImgLand', function(newVal, oldVal){
      if (newVal === oldVal) {
        vm.loadLand = false;
        return;
      }

      if (newVal === null){
        vm.loadLand = false;
        return;
      }

      vm.loadLand = true;
      UploadService.save('channels', newVal, 'img-web-l', $stateParams.id).then(function(fileName){
        vm.loadLand = false;
        vm.model['img-web-l'] = fileName;
        vm.pathImgLand = fileName;
      });
    });

    $scope.$on("$destroy", function(){
      watch();
      watch1();
      watch2();
      watch3();
      watch4();
      watch5();
      watch6();
      watch7();
      watch8();
      watch9();
      watch10();
      watch11();
      watch12();
      watch13();
      watch14();
      watch15();
    });

  }

})();
